const STORAGE_KEY = "aiksol_measurement_books";

export const getMeasurementBooks = () => {
  try {
    const records = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(records) ? records : [];
  } catch {
    return [];
  }
};

export const saveMeasurementBook = (record) => {
  const records = getMeasurementBooks();
  const nextRecord = {
    ...record,
    Id: record.Id || `mb-${Date.now()}`,
    CreatedAt: record.CreatedAt || new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify([nextRecord, ...records]));
  return nextRecord;
};
